import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { deepClone } from '@lx/shared/utils';
import { SortingCriteria } from '@lx/shared/types';
import { MotherTongueService } from '@lx/shared/data-access/destination';
import { Language as MotherTongue } from '@lx/language';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lx-mother-tongue',
  templateUrl: './mother-tongue-selector.component.html',
  styleUrls: ['./mother-tongue-selector.component.scss'],
})
export class MotherTongueSelectorComponent implements OnInit, OnDestroy, OnChanges {
  @Input() small = false;
  @Input() label: string;
  @Input() disabled = false;
  @Input() placeholder: string;
  @Input() value: string = undefined;
  @Input() sortCriteria: SortingCriteria<MotherTongue>;
  @Input() required = false;
  @Output() valueChange = new EventEmitter<string>();
  @Output() dropdownClosed = new EventEmitter<void>();

  private subscription = new Subscription();

  public motherTongues: MotherTongue[] = [];
  public selectedValue: string;
  public dirty = false;

  constructor(private motherTongueService: MotherTongueService) {}

  private getItemList() {
    this.subscription.add(
      this.motherTongueService.getAll().subscribe((data) => {
        this.motherTongues = data.map(deepClone);
      }),
    );
  }

  ngOnInit() {
    this.getItemList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value?.currentValue) {
      this.selectedValue = changes.value.currentValue;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
